/** Register Menbirinchi service worker (production / HTTPS). */
export function registerPwa() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  const isLocal =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';

  // Allow local test; production always
  if (process.env.NODE_ENV !== 'production' && !isLocal) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* ignore — install prompt simply won't appear */
    });
  });
}
